// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-light: #eef2ff;
  --success-color: #10b981;
  --danger-color: #ef4444;
  --warning-color: #f59e0b;
  --text-dark: #1f2937;
  --text-medium: #4b5563;
  --text-light: #9ca3af;
  --bg-light: #f9fafb;
  --card-bg: #ffffff;
  --border-light: #e5e7eb;
  --border-radius: 12px;
  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  --transition: all 0.3s ease;
}

.user-detail-container {
  padding: 1rem;
  background-color: #f4f6f8;
  display: flex;
}

.user-card {
  background-color: var(--card-bg);
  border-radius: var(--border-radius-primary);
  box-shadow: var(--box-shadow);
  width: 100%;
  padding: 2rem;
}

.user-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid var(--border-light);
}
.user-header .user-header-data {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.client-actions {
  display: flex;
  gap: 0.75rem;
}
.client-actions button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s;
}
.client-actions button.btn-update {
  background-color: var(--primary-light-bg);
  color: var(--primary-color);
  border: 1px solid var(--primary-color);
}
.client-actions button.btn-update:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}
.client-actions button.btn-delete {
  background-color: var(--danger-light-bg);
  color: var(--danger-color);
  border: 1px solid var(--danger-color);
}
.client-actions button.btn-delete:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.avatar {
  width: 64px;
  height: 64px;
  background-color: var(--primary-light);
  color: var(--primary-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  font-weight: bold;
  margin-right: 1.5rem;
}

.user-title h2 {
  margin: 0;
  color: var(--text-dark);
  font-size: 1.5rem;
  font-weight: 600;
}

.user-status {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 500;
  margin-top: 0.5rem;
}
.user-status.active {
  background-color: rgba(16, 185, 129, 0.1);
  color: var(--success-color);
}
.user-status.inactive {
  background-color: rgba(239, 68, 68, 0.1);
  color: var(--danger-color);
}

.user-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.view-user-detailspage--detail-item {
  display: flex;
  gap: 1rem;
}
.view-user-detailspage--detail-item .icon {
  color: var(--primary-color);
  font-size: 1.25rem;
  flex-shrink: 0;
}
.view-user-detailspage--detail-item label {
  display: block;
  color: var(--text-light);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
}
.view-user-detailspage--detail-item p {
  margin: 0;
  color: var(--text-dark);
  font-size: 0.95rem;
  font-weight: 500;
}

.role-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  background-color: var(--primary-light);
  color: var(--primary-color);
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
}

.role-display {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.role-display .role-edit-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-light);
  padding: 0.2rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  transition: var(--transition);
}
.role-display .role-edit-btn:hover {
  color: var(--primary-color);
  background-color: var(--primary-light);
}
.role-display .role-edit-btn svg {
  font-size: 0.85rem;
}

.role-change-inline {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}
.role-change-inline .role-select {
  padding: 0.2rem 0.5rem;
  border: 1px solid var(--border-light);
  border-radius: 6px;
  font-size: 0.85rem;
  color: var(--text-dark);
  background-color: white;
  cursor: pointer;
}
.role-change-inline .role-select:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(67, 97, 238, 0.1);
}
.role-change-inline .role-select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.role-change-inline .role-save-btn,
.role-change-inline .role-cancel-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  transition: var(--transition);
}
.role-change-inline .role-save-btn svg,
.role-change-inline .role-cancel-btn svg {
  font-size: 1.1rem;
}
.role-change-inline .role-save-btn:disabled,
.role-change-inline .role-cancel-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.role-change-inline .role-save-btn {
  color: var(--success-color);
}
.role-change-inline .role-save-btn:hover:not(:disabled) {
  background-color: rgba(16, 185, 129, 0.1);
}
.role-change-inline .role-cancel-btn {
  color: var(--danger-color);
}
.role-change-inline .role-cancel-btn:hover:not(:disabled) {
  background-color: rgba(239, 68, 68, 0.1);
}
.role-change-inline .role-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(16, 185, 129, 0.2);
  border-top-color: var(--success-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.case-assignments-section {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid var(--border-light);
}
.case-assignments-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}
.case-assignments-section .section-header .section-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.case-assignments-section .section-header .section-title .icon {
  color: var(--primary-color);
  font-size: 1.25rem;
}
.case-assignments-section .section-header .section-title h3 {
  margin: 0;
  color: var(--text-dark);
  font-size: 1.25rem;
  font-weight: 600;
}
.case-assignments-section .section-header .add-case-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 8px 18px;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition);
}
.case-assignments-section .section-header .add-case-btn:hover {
  background-color: #3c5ce6;
  transform: translateY(-1px);
}
.case-assignments-section .section-header .add-case-btn svg {
  font-size: 1rem;
}

.add-case-form {
  background-color: var(--bg-light);
  border: 1px solid var(--border-light);
  border-radius: var(--border-radius);
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}
.add-case-form .form-header {
  margin-bottom: 1rem;
}
.add-case-form .form-header h4 {
  margin: 0;
  color: var(--text-dark);
  font-size: 1rem;
  font-weight: 600;
}
.add-case-form .form-content {
  display: flex;
  gap: 1rem;
  align-items: flex-end;
}
.add-case-form .form-content .case-selector-dropdown {
  flex: 1 1;
  position: relative;
}
.add-case-form .form-content .case-selector-dropdown label {
  display: block;
  color: var(--text-medium);
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-wrapper {
  position: relative;
}
.add-case-form .form-content .case-selector-dropdown .search-input-container {
  position: relative;
  display: flex;
  align-items: center;
}
.add-case-form .form-content .case-selector-dropdown .search-input-container .search-input {
  width: 100%;
  padding: 0.75rem 2.5rem 0.75rem 0.75rem;
  border: 1px solid var(--border-light);
  border-radius: 8px;
  font-size: 0.875rem;
  background-color: white;
  transition: var(--transition);
}
.add-case-form .form-content .case-selector-dropdown .search-input-container .search-input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(67, 97, 238, 0.1);
}
.add-case-form .form-content .case-selector-dropdown .search-input-container .search-input::placeholder {
  color: var(--text-light);
}
.add-case-form .form-content .case-selector-dropdown .search-input-container .dropdown-arrow {
  position: absolute;
  right: 0.75rem;
  color: var(--text-light);
  pointer-events: none;
}
.add-case-form .form-content .case-selector-dropdown .case-selector {
  position: relative;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .custom-dropdown-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .custom-dropdown-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.add-case-form .form-content .case-selector-dropdown .case-selector .custom-dropdown-input:hover:not(:focus) {
  border-color: #9ca3af;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .custom-dropdown-input::placeholder {
  color: #9ca3af;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  z-index: 1000;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  margin-top: 0.25rem;
  overflow: hidden;
  animation: dropdown-fade-in 0.2s ease-out;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content .dropdown-tabs {
  display: flex;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content .dropdown-tabs button {
  flex: 1 1;
  padding: 0.75rem 1rem;
  border: none;
  background: transparent;
  color: #6b7280;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 2px solid transparent;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content .dropdown-tabs button:hover {
  background: #f3f4f6;
  color: #374151;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content .dropdown-tabs button.active {
  background: #ffffff;
  color: #3b82f6;
  font-weight: 600;
  border-bottom-color: #3b82f6;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content .dropdown-options {
  max-height: 250px;
  overflow-y: auto;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content .dropdown-options .dropdown-option {
  padding: 0.75rem 1rem;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
  transition: all 0.2s ease;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content .dropdown-options .dropdown-option:hover {
  background: #f9fafb;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content .dropdown-options .dropdown-option.selected {
  background: #eff6ff;
  color: #1e40af;
  border-left: 3px solid #3b82f6;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content .dropdown-options .dropdown-option.selected .case-parties {
  font-weight: 600;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-parties {
  font-weight: 500;
  color: #374151;
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
  line-height: 1.4;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-ref {
  font-size: 0.75rem;
  color: #6b7280;
  font-family: ui-monospace, SFMono-Regular, "SF Mono", Consolas, "Liberation Mono", Menlo, monospace;
  background: #f3f4f6;
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  display: inline-block;
  margin-bottom: 0.25rem;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-number {
  font-size: 0.75rem;
  color: #9ca3af;
}
.add-case-form .form-content .case-selector-dropdown .case-selector .dropdown-content .dropdown-options .no-data {
  padding: 2rem 1rem;
  text-align: center;
  color: #6b7280;
  font-style: italic;
  font-size: 0.875rem;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: white;
  border: 1px solid var(--border-light);
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-height: 400px;
  overflow: hidden;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-header {
  border-bottom: 1px solid var(--border-light);
  padding: 0;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-header .court-tabs {
  display: flex;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-header .court-tabs .tab-btn {
  flex: 1 1;
  padding: 0.75rem;
  border: none;
  background-color: var(--bg-light);
  color: var(--text-medium);
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition);
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-header .court-tabs .tab-btn:first-child {
  border-top-left-radius: 8px;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-header .court-tabs .tab-btn:last-child {
  border-top-right-radius: 8px;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-header .court-tabs .tab-btn.active {
  background-color: var(--primary-color);
  color: white;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-header .court-tabs .tab-btn:hover:not(.active) {
  background-color: #e5e7eb;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-content {
  max-height: 320px;
  overflow-y: auto;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-content .loading-state,
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-content .empty-state,
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-content .no-results {
  padding: 2rem;
  text-align: center;
  color: var(--text-light);
  font-size: 0.875rem;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-content .cases-list .case-option {
  padding: 0.75rem;
  border-bottom: 1px solid var(--border-light);
  cursor: pointer;
  transition: var(--transition);
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-content .cases-list .case-option:hover {
  background-color: var(--bg-light);
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-content .cases-list .case-option:last-child {
  border-bottom: none;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-content .cases-list .case-option .case-details .case-parties {
  font-weight: 500;
  color: var(--text-dark);
  margin-bottom: 0.25rem;
  font-size: 0.875rem;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-content .cases-list .case-option .case-details .case-ref {
  color: var(--primary-color);
  font-size: 0.8rem;
  font-weight: 500;
  margin-bottom: 0.25rem;
}
.add-case-form .form-content .case-selector-dropdown .dropdown-menu .dropdown-content .cases-list .case-option .case-details .case-number {
  color: var(--text-light);
  font-size: 0.75rem;
}
.add-case-form .form-content .form-actions {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  flex-shrink: 0;
}
.add-case-form .form-content .form-actions .save-btn,
.add-case-form .form-content .form-actions .cancel-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition);
  border: none;
  white-space: nowrap;
}
.add-case-form .form-content .form-actions .save-btn {
  background-color: var(--success-color);
  color: white;
}
.add-case-form .form-content .form-actions .save-btn:hover:not(:disabled) {
  background-color: #059669;
}
.add-case-form .form-content .form-actions .save-btn:disabled {
  background-color: var(--text-light);
  cursor: not-allowed;
}
.add-case-form .form-content .form-actions .cancel-btn {
  background-color: transparent;
  color: var(--text-medium);
  border: 1px solid var(--border-light);
}
.add-case-form .form-content .form-actions .cancel-btn:hover {
  background-color: var(--bg-light);
}

.case-assignments-list .loading-state,
.case-assignments-list .empty-state {
  padding: 3rem 2rem;
  text-align: center;
  color: var(--text-light);
  font-size: 0.875rem;
  background-color: var(--bg-light);
  border-radius: var(--border-radius);
  border: 1px solid var(--border-light);
}
.case-assignments-list .assignments-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1rem;
}
.case-assignments-list .assignments-grid .assignment-card {
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  background-color: white;
  border: 1px solid var(--border-light);
  border-radius: 8px;
  transition: var(--transition);
}
.case-assignments-list .assignments-grid .assignment-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.case-assignments-list .assignments-grid .assignment-card .assignment-info {
  flex: 1 1;
}
.case-assignments-list .assignments-grid .assignment-card .assignment-info .court-ref {
  font-weight: 600;
  color: var(--text-dark);
  margin-bottom: 0.25rem;
  font-size: 0.95rem;
}
.case-assignments-list .assignments-grid .assignment-card .assignment-info .parties-info {
  color: var(--text-medium);
  font-size: 0.85rem;
  margin-bottom: 0.25rem;
  line-height: 1.3;
}
.case-assignments-list .assignments-grid .assignment-card .assignment-info .source-info {
  color: var(--warning-color);
  font-size: 0.75rem;
  font-weight: 500;
  margin-bottom: 0.25rem;
  text-transform: capitalize;
}
.case-assignments-list .assignments-grid .assignment-card .assignment-info .assignment-meta .created-date {
  color: var(--text-light);
  font-size: 0.75rem;
}
.case-assignments-list .assignments-grid .assignment-card .delete-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: transparent;
  color: var(--danger-color);
  border: 1px solid var(--danger-color);
  border-radius: 6px;
  cursor: pointer;
  transition: var(--transition);
}
.case-assignments-list .assignments-grid .assignment-card .delete-btn:hover:not(:disabled) {
  background-color: var(--danger-color);
  color: white;
}
.case-assignments-list .assignments-grid .assignment-card .delete-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.case-assignments-list .assignments-grid .assignment-card .delete-btn svg {
  font-size: 0.875rem;
}
.case-assignments-list .assignments-grid .assignment-card .delete-btn .mini-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(239, 68, 68, 0.2);
  border-top-color: var(--danger-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(67, 97, 238, 0.2);
  border-top-color: var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

.error-message {
  color: var(--danger-color);
  font-size: 1rem;
  padding: 2rem;
  text-align: center;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes dropdown-fade-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar {
  width: 6px;
}

.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}

.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

@media (max-width: 768px) {
  .user-detail-container {
    padding: 1rem;
  }
  .user-card {
    padding: 1.5rem;
  }
  .user-details-grid {
    grid-template-columns: 1fr;
  }
  .case-assignments-section .section-header {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }
  .case-assignments-section .section-header .add-case-btn {
    justify-content: center;
  }
  .assignments-grid {
    grid-template-columns: 1fr;
  }
  .add-case-form {
    padding: 1rem;
  }
  .add-case-form .form-content {
    flex-direction: column;
    align-items: stretch;
  }
  .add-case-form .form-content .form-actions {
    justify-content: flex-start;
  }
  .add-case-form .form-content .form-actions .save-btn,
  .add-case-form .form-content .form-actions .cancel-btn {
    flex: none;
  }
  .case-selector-dropdown .dropdown-menu .dropdown-header .court-tabs .tab-btn {
    padding: 0.5rem;
    font-size: 0.8rem;
  }
}
@media (max-width: 480px) {
  .user-header {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }
  .user-header .avatar {
    margin-right: 0;
  }
  .view-user-detailspage--detail-item .icon {
    margin-top: 0;
  }
  .assignment-card {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }
  .assignment-card .delete-btn {
    align-self: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/UserDetailsPage/UserDetailsPage.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,wBAAA;EACA,uBAAA;EACA,wBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,4CAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,aAAA;AACF;;AAGA;EACE,gCAAA;EACA,2CAAA;EACA,6BAAA;EACA,WAAA;EACA,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,4CAAA;AAAF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAAJ;;AAIE;EACA,aAAA;EACA,YAAA;AADF;AAGE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AADJ;AAGI;EACE,yCAAA;EACA,2BAAA;EACA,sCAAA;AADN;AAGM;EACE,YAAA;EACA,2BAAA;AADR;AAKI;EACE,wCAAA;EACA,0BAAA;EACA,qCAAA;AAHN;AAKM;EACE,YAAA;EACA,2BAAA;AAHR;;AASA;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;AANF;;AAUE;EACE,SAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;AAPJ;;AAWA;EACE,qBAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AARF;AAUE;EACE,yCAAA;EACA,2BAAA;AARJ;AAWE;EACE,wCAAA;EACA,0BAAA;AATJ;;AAaA;EACE,aAAA;EACA,4DAAA;EACA,WAAA;EACA,mBAAA;AAVF;;AAaA;EACE,aAAA;EAEA,SAAA;AAXF;AAcE;EACE,2BAAA;EACA,kBAAA;EAEA,cAAA;AAbJ;AAgBE;EACE,cAAA;EACA,wBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;AAdJ;AAiBE;EACE,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAfJ;;AAmBA;EACE,qBAAA;EACA,wBAAA;EACA,sCAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAhBF;AAkBE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AAhBJ;AAkBI;EACE,2BAAA;EACA,sCAAA;AAhBN;AAmBI;EAAM,kBAAA;AAhBV;;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAjBF;AAmBE;EACE,sBAAA;EACA,qCAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,uBAAA;EACA,eAAA;AAjBJ;AAmBI;EACE,aAAA;EACA,kCAAA;EACA,4CAAA;AAjBN;AAoBI;EAAa,YAAA;EAAc,mBAAA;AAhB/B;AAmBE;;EAEE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AAjBJ;AAmBI;;EAAM,iBAAA;AAfV;AAiBI;;EAAa,YAAA;EAAc,mBAAA;AAZ/B;AAeE;EACE,2BAAA;AAbJ;AAcI;EAAyB,yCAAA;AAX7B;AAcE;EACE,0BAAA;AAZJ;AAaI;EAAyB,wCAAA;AAV7B;AAaE;EACE,WAAA;EACA,YAAA;EACA,yCAAA;EACA,sCAAA;EACA,kBAAA;EACA,kCAAA;AAXJ;;AAgBA;EACE,gBAAA;EACA,iBAAA;EACA,yCAAA;AAbF;AAeE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;AAbJ;AAeI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAbN;AAeM;EACE,2BAAA;EACA,kBAAA;AAbR;AAgBM;EACE,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAdR;AAkBI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;AAhBN;AAkBM;EACE,yBAAA;EACA,2BAAA;AAhBR;AAmBM;EACE,eAAA;AAjBR;;AAuBA;EACE,iCAAA;EACA,qCAAA;EACA,mCAAA;EACA,eAAA;EACA,qBAAA;AApBF;AAsBE;EACE,mBAAA;AApBJ;AAsBI;EACE,SAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AApBN;AAyBE;EACE,aAAA;EACA,SAAA;EACA,qBAAA;AAvBJ;AAyBI;EACE,SAAA;EACA,kBAAA;AAvBN;AAyBM;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AAvBR;AA0BM;EACE,kBAAA;AAxBR;AA2BM;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAzBR;AA2BQ;EACE,WAAA;EACA,uCAAA;EACA,qCAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AAzBV;AA2BU;EACE,aAAA;EACA,kCAAA;EACA,4CAAA;AAzBZ;AA4BU;EACE,wBAAA;AA1BZ;AA8BQ;EACE,kBAAA;EACA,cAAA;EACA,wBAAA;EACA,oBAAA;AA5BV;AAiCM;EACE,kBAAA;AA/BR;AAiCQ;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AA/BV;AAiCU;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA/BZ;AAkCU;EACE,qBAAA;AAhCZ;AAmCU;EACE,cAAA;AAjCZ;AAqCQ;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,qFAAA;EAEA,mBAAA;EACA,gBAAA;EACA,yCAAA;AApCV;AAsCU;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;AApCZ;AAsCY;EACE,SAAA;EACA,qBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,oCAAA;AApCd;AAsCc;EACE,mBAAA;EACA,cAAA;AApChB;AAuCc;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,4BAAA;AArChB;AA0CU;EACE,iBAAA;EACA,gBAAA;AAxCZ;AA0CY;EACE,qBAAA;EACA,eAAA;EACA,gCAAA;EACA,yBAAA;AAxCd;AA0Cc;EACE,mBAAA;AAxChB;AA2Cc;EACE,mBAAA;EACA,cAAA;EACA,8BAAA;AAzChB;AA2CgB;EACE,gBAAA;AAzClB;AA8CgB;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AA5ClB;AA+CgB;EACE,kBAAA;EACA,cAAA;EACA,mGAAA;EAEA,mBAAA;EACA,0BAAA;EACA,sBAAA;EACA,qBAAA;EACA,sBAAA;AA9ClB;AAiDgB;EACE,kBAAA;EACA,cAAA;AA/ClB;AAoDY;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAlDd;AAwDM;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,uBAAA;EACA,qCAAA;EACA,kBAAA;EACA,0CAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AAtDR;AAwDQ;EACE,4CAAA;EACA,UAAA;AAtDV;AAwDU;EACE,aAAA;AAtDZ;AAwDY;EACE,SAAA;EACA,gBAAA;EACA,YAAA;EACA,iCAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;AAtDd;AAwDc;EACE,2BAAA;AAtDhB;AAyDc;EACE,4BAAA;AAvDhB;AA0Dc;EACE,sCAAA;EACA,YAAA;AAxDhB;AA2Dc;EACE,yBAAA;AAzDhB;AA+DQ;EACE,iBAAA;EACA,gBAAA;AA7DV;AA+DU;;;EAGE,aAAA;EACA,kBAAA;EACA,wBAAA;EACA,mBAAA;AA7DZ;AAiEY;EACE,gBAAA;EACA,4CAAA;EACA,eAAA;EACA,6BAAA;AA/Dd;AAiEc;EACE,iCAAA;AA/DhB;AAkEc;EACE,mBAAA;AAhEhB;AAoEgB;EACE,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AAlElB;AAqEgB;EACE,2BAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AAnElB;AAsEgB;EACE,wBAAA;EACA,kBAAA;AApElB;AA6EI;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AA3EN;AA6EM;;EAEE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,YAAA;EACA,mBAAA;AA3ER;AA8EM;EACE,sCAAA;EACA,YAAA;AA5ER;AA8EQ;EACE,yBAAA;AA5EV;AA+EQ;EACE,mCAAA;EACA,mBAAA;AA7EV;AAiFM;EACE,6BAAA;EACA,yBAAA;EACA,qCAAA;AA/ER;AAiFQ;EACE,iCAAA;AA/EV;;AAyFE;;EAEE,kBAAA;EACA,kBAAA;EACA,wBAAA;EACA,mBAAA;EACA,iCAAA;EACA,mCAAA;EACA,qCAAA;AAtFJ;AAyFE;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AAvFJ;AAyFI;EACE,aAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,qCAAA;EACA,kBAAA;EACA,6BAAA;AAvFN;AAyFM;EACE,yCAAA;AAvFR;AA2FM;EACE,SAAA;AAzFR;AA2FQ;EACE,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;AAzFV;AA4FQ;EACE,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;AA1FV;AA6FQ;EACE,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,0BAAA;AA3FV;AA+FU;EACE,wBAAA;EACA,kBAAA;AA7FZ;AAkGM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,0BAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;AAhGR;AAkGQ;EACE,qCAAA;EACA,YAAA;AAhGV;AAmGQ;EACE,YAAA;EACA,mBAAA;AAjGV;AAoGQ;EACE,mBAAA;AAlGV;AAqGQ;EACE,WAAA;EACA,YAAA;EACA,wCAAA;EACA,qCAAA;EACA,kBAAA;EACA,kCAAA;AAnGV;;AA0GA;EACE,WAAA;EACA,YAAA;EACA,wCAAA;EACA,sCAAA;EACA,kBAAA;EACA,kCAAA;EACA,cAAA;AAvGF;;AA0GA;EACE,0BAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AAvGF;;AA2GA;EACE;IACE,yBAAA;EAxGF;AACF;AA2GA;EACE;IACE,UAAA;IACA,2BAAA;EAzGF;EA4GA;IACE,UAAA;IACA,wBAAA;EA1GF;AACF;AA8GA;EACE,UAAA;AA5GF;;AA+GA;EACE,mBAAA;EACA,kBAAA;AA5GF;;AA+GA;EACE,mBAAA;EACA,kBAAA;EACA,8CAAA;EAAA,sCAAA;AA5GF;;AA+GA;EACE,mBAAA;AA5GF;;AAgHA;EACE;IACE,aAAA;EA7GF;EAgHA;IACE,eAAA;EA9GF;EAiHA;IACE,0BAAA;EA/GF;EAmHE;IACE,sBAAA;IACA,SAAA;IACA,oBAAA;EAjHJ;EAmHI;IACE,uBAAA;EAjHN;EAsHA;IACE,0BAAA;EApHF;EAuHA;IACE,aAAA;EArHF;EAuHE;IACE,sBAAA;IACA,oBAAA;EArHJ;EAuHI;IACE,2BAAA;EArHN;EAuHM;;IAEE,UAAA;EArHR;EA+HQ;IACE,eAAA;IACA,iBAAA;EA7HV;AACF;AAoIA;EACE;IACE,sBAAA;IACA,kBAAA;IACA,SAAA;EAlIF;EAoIE;IACE,eAAA;EAlIJ;EAuIE;IACE,aAAA;EArIJ;EAyIA;IACE,sBAAA;IACA,SAAA;IACA,oBAAA;EAvIF;EAyIE;IACE,kBAAA;EAvIJ;AACF","sourcesContent":[":root {\n  --primary-light: #eef2ff;\n  --success-color: #10b981;\n  --danger-color: #ef4444;\n  --warning-color: #f59e0b;\n  --text-dark: #1f2937;\n  --text-medium: #4b5563;\n  --text-light: #9ca3af;\n  --bg-light: #f9fafb;\n  --card-bg: #ffffff;\n  --border-light: #e5e7eb;\n  --border-radius: 12px;\n  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n  --transition: all 0.3s ease;\n}\n\n.user-detail-container {\n  padding: 1rem;\n  background-color:#f4f6f8;\n  display: flex;\n  // min-height: 100vh;\n}\n\n.user-card {\n  background-color: var(--card-bg);\n  border-radius: var(--border-radius-primary);\n  box-shadow: var(--box-shadow);\n  width: 100%;\n  padding: 2rem;\n}\n\n.user-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 2rem;\n  padding-bottom: 1.5rem;\n  border-bottom: 1px solid var(--border-light);\n\n  .user-header-data {\n    display: flex;\n    align-items: center;\n    gap: 1.5rem;\n  }\n}\n\n  .client-actions {\n  display: flex;\n  gap: 0.75rem;\n  \n  button {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.5rem 1rem;\n    border-radius: 6px;\n    border: none;\n    cursor: pointer;\n    font-size: 0.875rem;\n    font-weight: 500;\n    transition: all 0.2s;\n    \n    &.btn-update {\n      background-color: var(--primary-light-bg);\n      color: var(--primary-color);\n      border: 1px solid var(--primary-color);\n      \n      &:hover {\n        opacity: 0.9;\n        transform: translateY(-1px);\n      }\n    }\n    \n    &.btn-delete {\n      background-color: var(--danger-light-bg);\n      color: var(--danger-color);\n      border: 1px solid var(--danger-color);\n      \n      &:hover {\n        opacity: 0.9;\n        transform: translateY(-1px);\n      }\n    }\n  }\n}\n\n.avatar {\n  width: 64px;\n  height: 64px;\n  background-color: var(--primary-light);\n  color: var(--primary-color);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.75rem;\n  font-weight: bold;\n  margin-right: 1.5rem;\n}\n\n.user-title {\n  h2 {\n    margin: 0;\n    color: var(--text-dark);\n    font-size: 1.5rem;\n    font-weight: 600;\n  }\n}\n\n.user-status {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  margin-top: 0.5rem;\n\n  &.active {\n    background-color: rgba(16, 185, 129, 0.1);\n    color: var(--success-color);\n  }\n\n  &.inactive {\n    background-color: rgba(239, 68, 68, 0.1);\n    color: var(--danger-color);\n  }\n}\n\n.user-details-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.view-user-detailspage--detail-item {\n  display: flex;\n  //align-items: flex-start;\n  gap: 1rem;\n  // align-items: center !important;\n\n  .icon {\n    color: var(--primary-color);\n    font-size: 1.25rem;\n    // margin-top: 0.25rem;\n    flex-shrink: 0;\n  }\n\n  label {\n    display: block;\n    color: var(--text-light);\n    font-size: 0.75rem;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-bottom: 0.25rem;\n  }\n\n  p {\n    margin: 0;\n    color: var(--text-dark);\n    font-size: 0.95rem;\n    font-weight: 500;\n  }\n}\n\n.role-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  background-color: var(--primary-light);\n  color: var(--primary-color);\n  border-radius: 20px;\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n.role-display {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n\n  .role-edit-btn {\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: var(--text-light);\n    padding: 0.2rem;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    transition: var(--transition);\n\n    &:hover {\n      color: var(--primary-color);\n      background-color: var(--primary-light);\n    }\n\n    svg { font-size: 0.85rem; }\n  }\n}\n\n.role-change-inline {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n\n  .role-select {\n    padding: 0.2rem 0.5rem;\n    border: 1px solid var(--border-light);\n    border-radius: 6px;\n    font-size: 0.85rem;\n    color: var(--text-dark);\n    background-color: white;\n    cursor: pointer;\n\n    &:focus {\n      outline: none;\n      border-color: var(--primary-color);\n      box-shadow: 0 0 0 2px rgba(67, 97, 238, 0.1);\n    }\n\n    &:disabled { opacity: 0.6; cursor: not-allowed; }\n  }\n\n  .role-save-btn,\n  .role-cancel-btn {\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 0.25rem;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    transition: var(--transition);\n\n    svg { font-size: 1.1rem; }\n\n    &:disabled { opacity: 0.5; cursor: not-allowed; }\n  }\n\n  .role-save-btn {\n    color: var(--success-color);\n    &:hover:not(:disabled) { background-color: rgba(16, 185, 129, 0.1); }\n  }\n\n  .role-cancel-btn {\n    color: var(--danger-color);\n    &:hover:not(:disabled) { background-color: rgba(239, 68, 68, 0.1); }\n  }\n\n  .role-spinner {\n    width: 14px;\n    height: 14px;\n    border: 2px solid rgba(16, 185, 129, 0.2);\n    border-top-color: var(--success-color);\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n  }\n}\n\n// Case Assignments Section\n.case-assignments-section {\n  margin-top: 2rem;\n  padding-top: 2rem;\n  border-top: 1px solid var(--border-light);\n\n  .section-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1.5rem;\n\n    .section-title {\n      display: flex;\n      align-items: center;\n      gap: 0.75rem;\n\n      .icon {\n        color: var(--primary-color);\n        font-size: 1.25rem;\n      }\n\n      h3 {\n        margin: 0;\n        color: var(--text-dark);\n        font-size: 1.25rem;\n        font-weight: 600;\n      }\n    }\n\n    .add-case-btn {\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n      padding : 8px 18px;\n      background-color: var(--primary-color);\n      color: white;\n      border: none;\n      border-radius: 8px;\n      font-size: 0.9rem;\n      font-weight: 500;\n      cursor: pointer;\n      transition: var(--transition);\n\n      &:hover {\n        background-color: #3c5ce6;\n        transform: translateY(-1px);\n      }\n\n      svg {\n        font-size: 1rem;\n      }\n    }\n  }\n}\n\n.add-case-form {\n  background-color: var(--bg-light);\n  border: 1px solid var(--border-light);\n  border-radius: var(--border-radius);\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n\n  .form-header {\n    margin-bottom: 1rem;\n\n    h4 {\n      margin: 0;\n      color: var(--text-dark);\n      font-size: 1rem;\n      font-weight: 600;\n    }\n  }\n\n  // Updated layout for input and actions in same row\n  .form-content {\n    display: flex;\n    gap: 1rem;\n    align-items: flex-end;\n\n    .case-selector-dropdown {\n      flex: 1;\n      position: relative;\n\n      label {\n        display: block;\n        color: var(--text-medium);\n        font-size: 0.875rem;\n        font-weight: 500;\n        margin-bottom: 0.5rem;\n      }\n\n      .dropdown-wrapper {\n        position: relative;\n      }\n\n      .search-input-container {\n        position: relative;\n        display: flex;\n        align-items: center;\n\n        .search-input {\n          width: 100%;\n          padding: 0.75rem 2.5rem 0.75rem 0.75rem;\n          border: 1px solid var(--border-light);\n          border-radius: 8px;\n          font-size: 0.875rem;\n          background-color: white;\n          transition: var(--transition);\n\n          &:focus {\n            outline: none;\n            border-color: var(--primary-color);\n            box-shadow: 0 0 0 3px rgba(67, 97, 238, 0.1);\n          }\n\n          &::placeholder {\n            color: var(--text-light);\n          }\n        }\n\n        .dropdown-arrow {\n          position: absolute;\n          right: 0.75rem;\n          color: var(--text-light);\n          pointer-events: none;\n        }\n      }\n\n      // Case Selector Dropdown - Updated to match ExpenseForm exactly\n      .case-selector {\n        position: relative;\n\n        .custom-dropdown-input {\n          width: 100%;\n          padding: 0.5rem;\n          border: 1px solid #d1d5db;\n          border-radius: 0.25rem;\n          font-size: 0.875rem;\n          font-family: inherit;\n          color: #374151;\n          background: #ffffff;\n          box-sizing: border-box;\n          height: 2.5rem;\n\n          &:focus {\n            outline: none;\n            border-color: #3b82f6;\n            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n          }\n\n          &:hover:not(:focus) {\n            border-color: #9ca3af;\n          }\n\n          &::placeholder {\n            color: #9ca3af;\n          }\n        }\n\n        .dropdown-content {\n          position: absolute;\n          top: 100%;\n          left: 0;\n          width: 100%;\n          background: #ffffff;\n          border: 1px solid #d1d5db;\n          border-radius: 0.375rem;\n          z-index: 1000;\n          box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1),\n            0 10px 10px -5px rgba(0, 0, 0, 0.04);\n          margin-top: 0.25rem;\n          overflow: hidden;\n          animation: dropdown-fade-in 0.2s ease-out;\n\n          .dropdown-tabs {\n            display: flex;\n            background: #f9fafb;\n            border-bottom: 1px solid #e5e7eb;\n\n            button {\n              flex: 1;\n              padding: 0.75rem 1rem;\n              border: none;\n              background: transparent;\n              color: #6b7280;\n              font-weight: 500;\n              font-size: 0.875rem;\n              cursor: pointer;\n              transition: all 0.2s ease;\n              border-bottom: 2px solid transparent;\n\n              &:hover {\n                background: #f3f4f6;\n                color: #374151;\n              }\n\n              &.active {\n                background: #ffffff;\n                color: #3b82f6;\n                font-weight: 600;\n                border-bottom-color: #3b82f6;\n              }\n            }\n          }\n\n          .dropdown-options {\n            max-height: 250px;\n            overflow-y: auto;\n\n            .dropdown-option {\n              padding: 0.75rem 1rem;\n              cursor: pointer;\n              border-bottom: 1px solid #f3f4f6;\n              transition: all 0.2s ease;\n\n              &:hover {\n                background: #f9fafb;\n              }\n\n              &.selected {\n                background: #eff6ff;\n                color: #1e40af;\n                border-left: 3px solid #3b82f6;\n\n                .case-parties {\n                  font-weight: 600;\n                }\n              }\n\n              .case-info {\n                .case-parties {\n                  font-weight: 500;\n                  color: #374151;\n                  font-size: 0.875rem;\n                  margin-bottom: 0.25rem;\n                  line-height: 1.4;\n                }\n\n                .case-ref {\n                  font-size: 0.75rem;\n                  color: #6b7280;\n                  font-family: ui-monospace, SFMono-Regular, \"SF Mono\", Consolas,\n                    \"Liberation Mono\", Menlo, monospace;\n                  background: #f3f4f6;\n                  padding: 0.125rem 0.375rem;\n                  border-radius: 0.25rem;\n                  display: inline-block;\n                  margin-bottom: 0.25rem;\n                }\n\n                .case-number {\n                  font-size: 0.75rem;\n                  color: #9ca3af;\n                }\n              }\n            }\n\n            .no-data {\n              padding: 2rem 1rem;\n              text-align: center;\n              color: #6b7280;\n              font-style: italic;\n              font-size: 0.875rem;\n            }\n          }\n        }\n      }\n\n      .dropdown-menu {\n        position: absolute;\n        top: 100%;\n        left: 0;\n        right: 0;\n        background-color: white;\n        border: 1px solid var(--border-light);\n        border-radius: 8px;\n        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n        z-index: 1000;\n        max-height: 400px;\n        overflow: hidden;\n\n        .dropdown-header {\n          border-bottom: 1px solid var(--border-light);\n          padding: 0;\n\n          .court-tabs {\n            display: flex;\n\n            .tab-btn {\n              flex: 1;\n              padding: 0.75rem;\n              border: none;\n              background-color: var(--bg-light);\n              color: var(--text-medium);\n              font-size: 0.875rem;\n              font-weight: 500;\n              cursor: pointer;\n              transition: var(--transition);\n\n              &:first-child {\n                border-top-left-radius: 8px;\n              }\n\n              &:last-child {\n                border-top-right-radius: 8px;\n              }\n\n              &.active {\n                background-color: var(--primary-color);\n                color: white;\n              }\n\n              &:hover:not(.active) {\n                background-color: #e5e7eb;\n              }\n            }\n          }\n        }\n\n        .dropdown-content {\n          max-height: 320px;\n          overflow-y: auto;\n\n          .loading-state,\n          .empty-state,\n          .no-results {\n            padding: 2rem;\n            text-align: center;\n            color: var(--text-light);\n            font-size: 0.875rem;\n          }\n\n          .cases-list {\n            .case-option {\n              padding: 0.75rem;\n              border-bottom: 1px solid var(--border-light);\n              cursor: pointer;\n              transition: var(--transition);\n\n              &:hover {\n                background-color: var(--bg-light);\n              }\n\n              &:last-child {\n                border-bottom: none;\n              }\n\n              .case-details {\n                .case-parties {\n                  font-weight: 500;\n                  color: var(--text-dark);\n                  margin-bottom: 0.25rem;\n                  font-size: 0.875rem;\n                }\n\n                .case-ref {\n                  color: var(--primary-color);\n                  font-size: 0.8rem;\n                  font-weight: 500;\n                  margin-bottom: 0.25rem;\n                }\n\n                .case-number {\n                  color: var(--text-light);\n                  font-size: 0.75rem;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .form-actions {\n      display: flex;\n      gap: 0.75rem;\n      align-items: center;\n      flex-shrink: 0; // Prevent shrinking\n\n      .save-btn,\n      .cancel-btn {\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n        padding: 0.75rem 1rem; // Match input height\n        border-radius: 6px;\n        font-size: 0.875rem;\n        font-weight: 500;\n        cursor: pointer;\n        transition: var(--transition);\n        border: none;\n        white-space: nowrap; // Prevent text wrapping\n      }\n\n      .save-btn {\n        background-color: var(--success-color);\n        color: white;\n\n        &:hover:not(:disabled) {\n          background-color: #059669;\n        }\n\n        &:disabled {\n          background-color: var(--text-light);\n          cursor: not-allowed;\n        }\n      }\n\n      .cancel-btn {\n        background-color: transparent;\n        color: var(--text-medium);\n        border: 1px solid var(--border-light);\n\n        &:hover {\n          background-color: var(--bg-light);\n        }\n      }\n    }\n  }\n}\n\n\n.case-assignments-list {\n\n  .loading-state,\n  .empty-state {\n    padding: 3rem 2rem;\n    text-align: center;\n    color: var(--text-light);\n    font-size: 0.875rem;\n    background-color: var(--bg-light);\n    border-radius: var(--border-radius);\n    border: 1px solid var(--border-light);\n  }\n\n  .assignments-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 1rem;\n\n    .assignment-card {\n      display: flex;\n      justify-content: space-between;\n      padding: 1rem;\n      background-color: white;\n      border: 1px solid var(--border-light);\n      border-radius: 8px;\n      transition: var(--transition);\n\n      &:hover {\n        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n        // border-color: var(--primary-color);\n      }\n\n      .assignment-info {\n        flex: 1;\n\n        .court-ref {\n          font-weight: 600;\n          color: var(--text-dark);\n          margin-bottom: 0.25rem;\n          font-size: 0.95rem;\n        }\n\n        .parties-info {\n          color: var(--text-medium);\n          font-size: 0.85rem;\n          margin-bottom: 0.25rem;\n          line-height: 1.3;\n        }\n\n        .source-info {\n          color: var(--warning-color);\n          font-size: 0.75rem;\n          font-weight: 500;\n          margin-bottom: 0.25rem;\n          text-transform: capitalize;\n        }\n\n        .assignment-meta {\n          .created-date {\n            color: var(--text-light);\n            font-size: 0.75rem;\n          }\n        }\n      }\n\n      .delete-btn {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 32px;\n        height: 32px;\n        background-color: transparent;\n        color: var(--danger-color);\n        border: 1px solid var(--danger-color);\n        border-radius: 6px;\n        cursor: pointer;\n        transition: var(--transition);\n\n        &:hover:not(:disabled) {\n          background-color: var(--danger-color);\n          color: white;\n        }\n\n        &:disabled {\n          opacity: 0.6;\n          cursor: not-allowed;\n        }\n\n        svg {\n          font-size: 0.875rem;\n        }\n\n        .mini-spinner {\n          width: 16px;\n          height: 16px;\n          border: 2px solid rgba(239, 68, 68, 0.2);\n          border-top-color: var(--danger-color);\n          border-radius: 50%;\n          animation: spin 1s linear infinite;\n        }\n      }\n    }\n  }\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid rgba(67, 97, 238, 0.2);\n  border-top-color: var(--primary-color);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto;\n}\n\n.error-message {\n  color: var(--danger-color);\n  font-size: 1rem;\n  padding: 2rem;\n  text-align: center;\n}\n\n// Animations\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes dropdown-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n// Scrollbar styling for dropdown - matching ExpenseForm\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar {\n  width: 6px;\n}\n\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 3px;\n}\n\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n  transition: background-color 0.2s ease;\n}\n\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n// Responsive Design\n@media (max-width: 768px) {\n  .user-detail-container {\n    padding: 1rem;\n  }\n\n  .user-card {\n    padding: 1.5rem;\n  }\n\n  .user-details-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .case-assignments-section {\n    .section-header {\n      flex-direction: column;\n      gap: 1rem;\n      align-items: stretch;\n\n      .add-case-btn {\n        justify-content: center;\n      }\n    }\n  }\n\n  .assignments-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .add-case-form {\n    padding: 1rem;\n\n    .form-content {\n      flex-direction: column;\n      align-items: stretch;\n\n      .form-actions {\n        justify-content: flex-start;\n\n        .save-btn,\n        .cancel-btn {\n          flex: none;\n        }\n      }\n    }\n  }\n\n  .case-selector-dropdown {\n    .dropdown-menu {\n      .dropdown-header {\n        .court-tabs {\n          .tab-btn {\n            padding: 0.5rem;\n            font-size: 0.8rem;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .user-header {\n    flex-direction: column;\n    text-align: center;\n    gap: 1rem;\n\n    .avatar {\n      margin-right: 0;\n    }\n  }\n\n  .view-user-detailspage--detail-item {\n    .icon {\n      margin-top: 0;\n    }\n  }\n\n  .assignment-card {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: stretch;\n\n    .delete-btn {\n      align-self: center;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
